/* Timbrica — /earthquake-map ("карта землетрясений" / live seismic map).
 *
 * Live "what just shook" map. Recent quakes (USGS + EMSC, merged server-side)
 * are drawn on a canvas overlay, sized by magnitude and coloured by depth; a
 * quake that arrives on a refresh pulses for a few seconds ("M5.2 · 12 s ago").
 * Data comes only from our same-origin /api/quakes/recent proxy (RU-safe).
 */
(function () {
  'use strict';
  var C = window.QUAKE_CFG || {};
  var T = C.t || {}, API = C.api || {};
  var tr = function (k) { return T[k] != null ? T[k] : k; };
  var $ = function (id) { return document.getElementById(id); };
  var ae = function (ev, p) { try { window.__ae && window.__ae(ev, p || {}); } catch (e) {} };

  /* Точки живут ПОВЕРХ подложки, поэтому у них две палитры, а не одна.
     Тёмная — исходная. Светлая нужна не «для красоты»: жёлтый #feca57 и
     голубой #48dbfb на почти белой плитке (positron, #fafaf8) сливаются с
     фоном, и шкала глубины перестаёт читаться. Заливка там же плотнее:
     на тёмном полупрозрачный цвет темнеет и остаётся насыщенным, на белом
     он ВЫцветает. Ту же светлую пятёрку повторяет полоска легенды в блейде —
     легенда обязана называть те цвета, которыми нарисованы точки. */
  var RAMP = {
    dark:  { c: ['#ff4d4f', '#ff9f43', '#feca57', '#48dbfb', '#5a86ff'], nil: '#ff7979', fill: 0.62, ink: '#fff', pulse: '#ff5e57' },
    light: { c: ['#d61f26', '#c25708', '#8a6d00', '#0b7fa8', '#2a45c4'], nil: '#b3363a', fill: 0.8,  ink: '#0b1020', pulse: '#d61f26' }
  };
  var skin = RAMP.dark;

  function depthColor(d) {
    if (d == null) return skin.nil;
    if (d < 33) return skin.c[0]; if (d < 70) return skin.c[1];
    if (d < 150) return skin.c[2]; if (d < 300) return skin.c[3]; return skin.c[4];
  }
  function magRadius(m) { return Math.max(3, (m - 1.2) * 2.7); }
  function fmtAgo(ms) {
    var s = Math.max(0, (Date.now() - ms) / 1000);
    if (s < 60) return tr('just_now');
    if (s < 3600) return Math.round(s / 60) + ' ' + tr('ago_min');
    if (s < 86400) return Math.round(s / 3600) + ' ' + tr('ago_hr');
    return Math.round(s / 86400) + ' ' + tr('ago_day');
  }

  var map = null, cv = null, quakes = [], filtered = [], minMag = 0, lastSeen = 0, first = true;
  var pulses = [], raf = null, sel = null, userLL = null, userDot = null;
  var stage = function (name) { try { window.__stage && window.__stage(name); } catch (e) {} };

  function initMap() {
    if (!window.L || !$('qkMap')) return;
    var tile = C.tile || {};
    map = L.map('qkMap', { center: [C.home ? C.home.lat : 20, C.home ? C.home.lon : 90], zoom: C.home ? C.home.z : 2, minZoom: 1, maxZoom: 12, worldCopyJump: true });
    // Подложка через общий примитив: запасной адрес и честная строка, если не
    // ответил ни один. Здесь стоял пустой .on('tileerror', function () {}) —
    // крючок был, внутри ничего, и упавший хост давал ЧЁРНЫЙ прямоугольник.
    if (window.__mapTiles) {
      window.__mapTiles.base(L, map, null, {
        slug: 'earthquake-map', credit: tr('map_attr'), opts: { maxZoom: 19 }, text: tile.offline,
        styles: tile.styles, labels: tile.labels,
        // Яркость подложки тянет за собой палитру точек и стекло панелей.
        onStyle: function (mode) {
          skin = RAMP[mode] || RAMP.dark;
          var stage = $('qkStage'); if (stage) stage.setAttribute('data-basemap', mode);
          if (sel) selectQuake(sel, true);   // карточка открыта — её цифра перекрашивается тоже
          redraw();
        }
      });
    } else if (window.__basemapFallback) {
      window.__basemapFallback(L, map, tr('map_attr'));
    }
    cv = document.createElement('canvas'); cv.className = 'qk-canvas';
    map.getPanes().overlayPane.appendChild(cv);
    // Одна перерисовка на кадр: Leaflet шлёт `move` чаще, чем экран успевает
    // показать, а каждая перерисовка проходит все события.
    map.on('move zoom resize viewreset moveend zoomend', schedule);
    cv.style.pointerEvents = 'none';
    map.on('click', onClick);
    // Сцена меняет размер не только вместе с окном: консоль перекладывается по
    // своей ширине (сайдбар, широкий режим, «на весь экран»), а Leaflet слушает
    // только resize окна — карта осталась бы нарисованной в прежнем боксе.
    if (window.ResizeObserver) {
      var roRaf = 0;
      new ResizeObserver(function () {
        if (roRaf) return;
        roRaf = requestAnimationFrame(function () { roRaf = 0; map.invalidateSize({ debounceMoveend: true }); });
      }).observe($('qkMap'));
    }
  }

  var drawRaf = 0;
  function schedule() {
    if (drawRaf || raf) return;          // идущая анимация пульса и так рисует каждый кадр
    drawRaf = requestAnimationFrame(function () { drawRaf = 0; redraw(); });
  }

  function applyFilter() { filtered = quakes.filter(function (q) { return q.mag >= minMag; }); }

  function redraw() {
    if (!map || !cv) return;
    var size = map.getSize(), dpr = window.devicePixelRatio || 1;
    // Буфер холста заводится заново ТОЛЬКО при смене размера: присваивание
    // width выделяло буфер в мегабайты на каждое событие перетаскивания.
    var bw = Math.round(size.x * dpr), bh = Math.round(size.y * dpr);
    if (cv.width !== bw || cv.height !== bh) {
      cv.width = bw; cv.height = bh;
      cv.style.width = size.x + 'px'; cv.style.height = size.y + 'px';
    }
    L.DomUtil.setPosition(cv, map.containerPointToLayerPoint([0, 0]));
    var ctx = cv.getContext('2d'); ctx.setTransform(dpr, 0, 0, dpr, 0, 0); ctx.clearRect(0, 0, size.x, size.y);
    var labels = [];
    for (var i = filtered.length - 1; i >= 0; i--) {
      var q = filtered[i], pt = map.latLngToContainerPoint([q.lat, q.lon]);
      if (pt.x < -30 || pt.y < -30 || pt.x > size.x + 30 || pt.y > size.y + 30) continue;
      var r = magRadius(q.mag), col = depthColor(q.depth);
      ctx.beginPath(); ctx.arc(pt.x, pt.y, r, 0, 6.2832);
      ctx.fillStyle = col; ctx.globalAlpha = skin.fill; ctx.fill();
      ctx.globalAlpha = 0.95; ctx.lineWidth = q === sel ? 2.5 : 1; ctx.strokeStyle = q === sel ? skin.ink : col; ctx.stroke();
      if (q.mag >= 6 || q === sel) labels.push({ q: q, x: pt.x + r + 2, y: pt.y + 4 });
    }
    // Подписи — поверх всех кружков и без наложения: толчок и его афтершок M6+
    // в паре километров печатали «6.7» и «6.8» одно по другому. Первым ставится
    // выбранное событие, дальше — по силе; подпись, которой нет места, опускается.
    if (labels.length) {
      labels.sort(function (a, b) { return (b.q === sel) - (a.q === sel) || b.q.mag - a.q.mag; });
      ctx.font = 'bold 11px system-ui'; ctx.globalAlpha = 0.9; ctx.fillStyle = skin.ink;
      var placed = [];
      for (var li = 0; li < labels.length; li++) {
        var L1 = labels[li], txt = L1.q.mag.toFixed(1), w = ctx.measureText(txt).width;
        var box = [L1.x - 1, L1.y - 10, L1.x + w + 1, L1.y + 2], hit = false;
        for (var pi = 0; pi < placed.length && !hit; pi++) {
          var P = placed[pi];
          hit = box[0] < P[2] && box[2] > P[0] && box[1] < P[3] && box[3] > P[1];
        }
        if (hit) continue;
        placed.push(box);
        ctx.fillText(txt, L1.x, L1.y);
      }
    }
    // pulses (new quakes)
    var now = performance.now();
    for (var j = 0; j < pulses.length; j++) {
      var p = pulses[j], age = now - p.t0, k = age / 1800 % 1, pq = p.q;
      var pp = map.latLngToContainerPoint([pq.lat, pq.lon]);
      ctx.beginPath(); ctx.arc(pp.x, pp.y, magRadius(pq.mag) + 4 + k * 26, 0, 6.2832);
      ctx.globalAlpha = (1 - k) * 0.7; ctx.lineWidth = 2; ctx.strokeStyle = skin.pulse; ctx.stroke();
    }
    ctx.globalAlpha = 1;
  }
  function ensureRaf() { if (drawRaf) { cancelAnimationFrame(drawRaf); drawRaf = 0; } if (!raf) raf = requestAnimationFrame(frame); }
  function frame(now) { redraw(); pulses = pulses.filter(function (p) { return now - p.t0 < 9000; }); if (pulses.length) raf = requestAnimationFrame(frame); else { raf = null; redraw(); } }

  function onClick(ev) {
    if (!filtered.length) return;
    var c = ev.containerPoint, best = null, bd = 1e9;
    for (var i = 0; i < filtered.length; i++) {
      var q = filtered[i], pt = map.latLngToContainerPoint([q.lat, q.lon]);
      var d = Math.hypot(pt.x - c.x, pt.y - c.y), rr = magRadius(q.mag) + 6;
      if (d <= rr && d < bd) { bd = d; best = q; }
    }
    if (best) selectQuake(best);
  }
  /* ── Последствия, цунами и прогноз ───────────────────────────────────
   *
   * Три вещи, которые USGS публикует, а карта не показывала. Магнитуда
   * отвечает «насколько сильно тряхнуло землю», и только эти три отвечают
   * «касается ли это людей»:
   *
   *   PAGER (`alert`) — оценка ПОСЛЕДСТВИЙ, а не силы. Замер 01.09.2026 по
   *     месячному фиду: M7.8 у Энде — ЖЁЛТЫЙ, M7.4 в Колумбии — КРАСНЫЙ,
   *     потому что там люди и мелкий очаг. По магнитуде эти два события
   *     стоят рядом, по последствиям — в разных мирах.
   *   `tsunami` — единственное в фиде, у чего есть ЗАПАС ПО ВРЕМЕНИ:
   *     волна идёт десятки минут, тряска — секунды.
   *   Прогноз афтершоков — единственное честное «что может быть дальше».
   */
  var PAGER = {
    green:  { c: '#2fa84f', k: 'impact_green' },
    yellow: { c: '#e0a33e', k: 'impact_yellow' },
    orange: { c: '#e8791f', k: 'impact_orange' },
    red:    { c: '#d33a2c', k: 'impact_red' }
  };

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* Где это — на языке страницы. Сейсмослужбы пишут место по-английски
     («HALMAHERA, INDONESIA», «45 km SSW of Tobelo, Indonesia»), и на русской
     странице это была единственная строка латиницей в карточке. Общий модуль
     GeoCity (public/js/geo-city.js) называет город со своим именем на языке
     страницы, его страну, румб и расстояние. Ближе 400 км города нет
     (середина океана) — остаётся подпись службы: «MID-ATLANTIC RIDGE» точнее
     «2 000 км от Понта-Делгады». */
  function placeOf(q) {
    if (!window.GeoCity) return;
    GeoCity.lookup(q.lat, q.lon, { mode: 'near' }).then(function (it) {
      var s = it && it.found ? GeoCity.text(it, { distance: true, country: true }) : '';
      var el = $('qkPlace');
      if (!s || !el || sel !== q) return;
      el.textContent = s;
      el.title = q.place || '';
    });
  }

  /* ── Куда ставить карточку события ──────────────────────────────────────
   * Рядом с картой, когда консоль в две колонки, и поверх карты, когда она
   * в одну (под картой высотой в 62 % экрана карточку не видно). Решает CSS —
   * переменная --qk-card у сетки под тем же @container, что раскладывает
   * колонки, — поэтому порог живёт в одном месте, а скрипт его только читает. */
  var cardMode = '';
  function hostMode() {
    var g = $('qkGrid');
    var v = g && window.getComputedStyle ? getComputedStyle(g).getPropertyValue('--qk-card').trim() : '';
    return v === 'rail' && $('qkCardRail') ? 'rail' : 'map';
  }
  function closeCard() {
    var c = $('qkCard'); if (c) { c.style.display = 'none'; c.innerHTML = ''; }
    var r = $('qkCardRail'); if (r) { r.hidden = true; r.innerHTML = ''; }
    var p = $('qkPrompt'); if (p) p.hidden = false;
  }
  function relayoutCard() {
    var m = hostMode();
    if (m === cardMode) return;
    cardMode = m;
    if (sel) selectQuake(sel, true);
  }

  function selectQuake(q, quiet) {
    sel = q; schedule();
    cardMode = hostMode();
    closeCard();
    var card = cardMode === 'rail' ? $('qkCardRail') : $('qkCard'); if (!card) return;
    var felt = q.felt ? '<div class="qk-row"><span>' + tr('felt_by') + '</span><b>' + esc(q.felt) + '</b></div>' : '';

    var pager = '';
    var pg = q.alert && PAGER[q.alert];
    if (pg) {
      pager = '<div class="qk-row"><span>' + tr('impact') + '</span>'
            + '<b class="qk-pager" style="background:' + pg.c + '">' + tr(pg.k) + '</b></div>';
    }

    var tsunami = q.tsunami
      ? '<div class="qk-tsunami">🌊 ' + tr('tsunami_flag') + '</div>'
      : '';

    card.innerHTML =
      '<button type="button" class="qk-x" id="qkX" aria-label="' + esc(tr('close')) + '">&times;</button>' +
      '<div class="qk-mag" style="color:' + depthColor(q.depth) + '">M ' + q.mag.toFixed(1) + '</div>' +
      '<div class="qk-place" id="qkPlace">' + esc(q.place) + '</div>' +
      tsunami +
      '<div class="qk-row"><span>' + tr('depth') + '</span><b>' + (q.depth != null ? q.depth + ' ' + tr('km') : '—') + '</b></div>' +
      '<div class="qk-row"><span>' + tr('time') + '</span><b>' + fmtAgo(q.time) + '</b></div>' +
      pager + felt +
      '<div class="qk-fc" id="qkFc" hidden></div>' +
      (q.url ? '<a class="qk-link" href="' + esc(q.url) + '" target="_blank" rel="noopener">' + tr('details') + ' (' + (q.src === 'usgs' ? 'USGS' : 'EMSC') + ') →</a>' : '');
    if (cardMode === 'rail') { card.hidden = false; var pr = $('qkPrompt'); if (pr) pr.hidden = true; }
    else card.style.display = 'block';
    var x = $('qkX'); if (x) x.onclick = function () { closeCard(); sel = null; schedule(); };
    placeOf(q);
    loadForecast(q);
    if (!quiet) ae('feature_use', { slug: 'earthquake-map', feature: 'select' });
  }

  /**
   * Прогноз афтершоков для выбранного события.
   *
   * Спрашивается ТОЛЬКО у заметных событий USGS: у EMSC такого продукта нет
   * вовсе, а ниже M4.5 USGS его почти не публикует — тянуть запрос на каждый
   * клик значило бы платить сотней запросов за три ответа.
   *
   * ⚠️ «Прогноза не публиковали» и «мы не дошли до USGS» — РАЗНЫЕ ответы, и
   * второй обязан быть НАЗВАН. Иначе отказ сети выглядит нормой: блок молча
   * не появляется ровно тогда, когда прогноз есть и нужен.
   */
  function loadForecast(q) {
    var box = $('qkFc');
    if (!box || !API.forecast) return;
    if (q.src !== 'usgs' || !q.id || q.mag < 4.5) return;

    var mine = q.id;
    fetch(API.forecast + '/' + encodeURIComponent(q.id), { credentials: 'omit' })
      .then(function (r) { return r.ok ? r.json() : { error: 'unavailable' }; })
      .catch(function () { return { error: 'unavailable' }; })
      .then(function (d) {
        // Человек уже выбрал другое событие — этот ответ не про него.
        if (!sel || sel.id !== mine) return;
        if (d && d.error) { show(box, '<div class="qk-fc-note">' + tr('forecast_error') + '</div>'); return; }
        if (!d || !d.available || !d.windows || !d.windows.length) return;   // норма: не публиковали

        var rows = d.windows.map(function (w) {
          // Из пяти порогов берём тот, что человек и спрашивает: «сильный
          // повторный толчок». M5 — порог, с которого афтершок сам по себе
          // способен навредить; ниже него это статистика для сейсмологов.
          var b = null;
          for (var i = 0; i < w.bins.length; i++) if (w.bins[i].mag === 5) b = w.bins[i];
          if (!b) b = w.bins[Math.min(2, w.bins.length - 1)];
          /* Округление до целого процента съедает именно тот конец шкалы,
             ради которого сюда и смотрят: 1.31% превращалось в «1%», а
             0.4% — в «0%», то есть в «не бывает». Десятая доля остаётся
             везде ниже 10%. */
          var p100 = b.p * 100;
          var pct = p100 >= 10 ? Math.round(p100) : p100.toFixed(1);
          return '<div class="qk-row"><span>' + esc(windowLabel(w.label)) + '</span><b>M' + b.mag + '+ · ' + pct + '%</b></div>';
        }).join('');

        show(box, '<div class="qk-fc-h">' + tr('forecast_title') + '</div>' + rows
                + '<div class="qk-fc-note">' + tr('forecast_note') + '</div>');
        ae('feature_use', { slug: 'earthquake-map', feature: 'aftershock_forecast' });
      });
  }

  function show(box, html) { box.innerHTML = html; box.hidden = false; }

  /* Горизонты прогноза приходят от USGS ПО-АНГЛИЙСКИ («1 Day», «1 Week»,
     «1 Month», «1 Year») — это их строки, а не наши. Без подмены русская
     страница печатала «1 Day», и блок выглядел непереведённым куском чужого
     сайта. Незнакомую метку оставляем как есть: лучше английское слово, чем
     пустая строка. */
  var FC_WINDOW = { '1 Day': 'fc_day', '1 Week': 'fc_week', '1 Month': 'fc_month', '1 Year': 'fc_year' };
  function windowLabel(label) {
    var k = FC_WINDOW[label];
    if (!k) return label;
    var v = T[k];
    return v == null || v === k ? label : v;
  }

  function jumpTo(q) { map.flyTo([q.lat, q.lon], Math.max(5, map.getZoom())); selectQuake(q); }

  function renderStats() {
    var s = $('qkStats');
    if (s) {
      if (!quakes.length) s.innerHTML = '';
      else {
        var big = quakes.reduce(function (a, b) { return b.mag > a.mag ? b : a; });
        var rec = quakes[0]; // sorted by time desc
        s.innerHTML =
          '<button type="button" class="qk-stat" id="qkBig">' + tr('biggest') + ' <b>M' + big.mag.toFixed(1) + '</b></button>' +
          '<button type="button" class="qk-stat" id="qkRec">' + tr('recent') + ' <b>M' + rec.mag.toFixed(1) + '</b> · ' + fmtAgo(rec.time) + '</button>';
        $('qkBig').onclick = function () { jumpTo(big); };
        $('qkRec').onclick = function () { jumpTo(rec); };
      }
    }
    renderStatus();
  }

  /* ── Загрузка ──────────────────────────────────────────────────────────
   * До 14.10.2026 отказ загрузки не кончался ничем: заставка «Загрузка…»
   * оставалась поверх карты навсегда (и перехватывала мышь), строка состояния
   * показывала «…», а следующая попытка ждала минуту. Проверено подменой ответа
   * на стенде. Теперь у запроса есть срок, отказ назван в строке состояния,
   * первые повторы идут через 5, 15 и 30 с. */
  var loadTimer = 0, loadBusy = false, loadFails = 0, loaded = false, stale = false, wantLoad = false;

  function renderStatus() {
    var cnt = $('qkCount'), upd = $('qkUpdWrap'), dot = $('qkDot');
    if (!cnt) return;
    if (!loaded) {
      if (!loadFails) return;
      cnt.textContent = tr('load_retry');
      if (upd) upd.hidden = true;
      if (dot) dot.classList.add('stale');
      return;
    }
    cnt.textContent = filtered.length + ' ' + tr('quakes_n');
    var rec = quakes[0];
    if (upd) upd.hidden = !rec;
    if (rec && $('qkUpd')) $('qkUpd').textContent = fmtAgo(rec.time);
    // Жёлтая точка — данные не самые свежие: сервер отдал последний известный
    // список или наш последний запрос не дошёл.
    if (dot) dot.classList.toggle('stale', stale || loadFails > 0);
  }

  function errText(err) { return String(err && err.name ? err.name + ': ' + err.message : err).slice(0, 120); }

  function fetchRecent() {
    var ctl = typeof AbortController === 'function' ? new AbortController() : null;
    // Срок — по ВИДИМОМУ времени: вкладку в фоне телефон замораживает, и срок по
    // стенным часам обрывал бы уже пришедший ответ в миг возвращения.
    var arm = typeof window.__visibleTimeout === 'function' ? window.__visibleTimeout : setTimeout;
    if (ctl) arm(function () { ctl.abort(); }, 20000);
    return fetch(API.recent, { credentials: 'omit', signal: ctl ? ctl.signal : undefined }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    }).then(function (d) {
      var list = (d && d.quakes) || [];
      // Пустой список с пометкой stale — сервер не дошёл ни до USGS, ни до EMSC
      // и не помнит последнего ответа. Это отказ, а не «тихий час на планете».
      if (!list.length && d && d.stale) throw new Error('empty_stale');
      return d;
    });
  }

  function plan(ms) {
    clearTimeout(loadTimer);
    loadTimer = setTimeout(function () {
      // Скрытую вкладку не опрашиваем: спросим, когда к ней вернутся, — тогда
      // и пульс нового события увидят, а не пропустят за спиной.
      if (document.hidden) { wantLoad = true; return; }
      load();
    }, ms);
  }

  function load() {
    if (loadBusy || !API.recent) return;
    loadBusy = true;
    fetchRecent().then(function (d) {
      loadBusy = false;
      var list = d.quakes || [];
      // detect new quakes since last poll → pulse
      if (!first) {
        for (var i = 0; i < list.length; i++) if (list[i].time > lastSeen) { pulses.push({ q: list[i], t0: performance.now() }); }
        if (pulses.length) ensureRaf();
      }
      if (list.length) lastSeen = list[0].time;
      first = false; loaded = true; loadFails = 0; stale = !!d.stale;
      quakes = list; applyFilter();
      plan(60000);
      return true;
    }, function (err) {
      loadBusy = false; loadFails++;
      if (loadFails === 1) ae('tool_error', { slug: 'earthquake-map', where: 'recent', msg: errText(err) });
      if (!loaded && loadFails === 1 && window.__announce) { try { window.__announce(tr('load_retry')); } catch (e) {} }
      plan(loaded ? 60000 : [5000, 15000, 30000, 60000][Math.min(loadFails - 1, 3)]);
      return false;
    }).then(function (ok) {
      // Отрисовка — вне ветки отказа: ошибка в ней не «данные не пришли», и
      // повторять из-за неё запрос незачем.
      var ld = $('qkLoading'); if (ld) ld.classList.add('hidden');
      if (ok) { schedule(); renderStats(); afterData(); } else renderStatus();
    });
  }

  /* Завершение объявляет общий примитив, когда события действительно
     показаны. Раньше `tool_complete` уходил при запуске, ДО данных, — и
     сессия, у которой карта так и осталась пустой, считалась удачной. */
  function afterData() {
    if (afterData.done) return;
    afterData.done = true; stage('data_shown');
    if (typeof window.__aeToolComplete === 'function') window.__aeToolComplete({}); else ae('tool_complete', { slug: 'earthquake-map' });
  }

  function locate() {
    // A bare `return` here was a literally silent dead click: the button
    // did nothing and said nothing. __geo.notify explains why and reports it.
    if (!navigator.geolocation) { if (window.__geo) __geo.notify('no_api'); return; }
    var b = $('qkLocate'); if (b) b.disabled = true;
    navigator.geolocation.getCurrentPosition(function (pos) {
      userLL = [pos.coords.latitude, pos.coords.longitude];
      map.flyTo(userLL, 5);
      // Одна метка «вы здесь»: каждое нажатие раньше добавляло ещё один кружок.
      if (userDot) userDot.setLatLng(userLL);
      else userDot = L.circleMarker(userLL, { radius: 6, color: '#7aa7ff', weight: 2, fillColor: '#7aa7ff', fillOpacity: .6, interactive: false }).addTo(map);
      ae('feature_use', { slug: 'earthquake-map', feature: 'locate' });
      if (b) b.disabled = false;
    }, function (err) { if (b) b.disabled = false; if (window.__geo) __geo.notify(err); }, { enableHighAccuracy: false, timeout: 8000, maximumAge: 600000 });
  }

  /* ── На весь экран ───────────────────────────────────────────────────────
   * Экран получает консоль ЦЕЛИКОМ — карта и рейка с карточкой события, как у
   * /lightning-map. Кнопка появляется лишь там, где браузер умеет отдать экран
   * элементу (на iPhone — только видео). */
  /* На весь экран — общая дверь сайта: настоящий полный экран, а где браузер
   * не отдаёт его элементу (iPhone), та же консоль наложением на всё окно.
   * Свою раскладку держит `.qk.tmb-whole`; вход считает сама дверь. */
  function initFullscreen() {
    var btn = $('qkFull'), app = $('qkApp');
    if (!btn || !app || typeof window.__wholeScreen !== 'function') return;
    var screen = window.__wholeScreen(app, { key: 'earthquake-map', onChange: function (on) {
      var label = tr(on ? 'fullscreen_exit' : 'fullscreen');
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.title = label; btn.setAttribute('aria-label', label);
    } });
    btn.hidden = false;
    btn.addEventListener('click', function () { screen.toggle(); });
  }

  function boot() {
    initMap(); load();
    var lb = $('qkLocate'); if (lb) lb.addEventListener('click', locate);
    var segs = document.querySelectorAll('.qk-filter .tc-seg-b');
    segs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        segs.forEach(function (x) { var on = x === btn; x.classList.toggle('on', on); x.setAttribute('aria-pressed', on ? 'true' : 'false'); });
        minMag = parseFloat(btn.getAttribute('data-mag')) || 0;
        // Открытая карточка события, которое фильтр убрал с карты, закрывается:
        // иначе она описывала бы точку, которой на карте нет.
        if (sel && sel.mag < minMag) { closeCard(); sel = null; }
        applyFilter(); schedule(); renderStatus();
        ae('feature_use', { slug: 'earthquake-map', feature: 'filter', mag: minMag });
      });
    });
    initFullscreen();
    cardMode = hostMode();
    var app = $('qkApp');
    if (window.ResizeObserver && app) new ResizeObserver(relayoutCard).observe(app);
    else window.addEventListener('resize', relayoutCard);
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden && wantLoad) { wantLoad = false; load(); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
